import { setEditPhoneNumberModal } from '../../../../../store/workspace/slice';
import VerificationStep from '../../components/VerificationStep';
import { EditSquareIcon, CheckSolidIcon } from '../../../../../assets/icons';
import { useCredentialReset } from '../../hooks/useCredentialReset';
import PhoneNumberInput from '../../../../../components/PhoneNumberInput';
import { selectProfile } from '../../../../../store/workspace/selectors';
import { useDispatch, useSelector } from '../../../../../store/store';
import styles from './style.module.scss';
import Modal from '../../../../../components/Modal';
import Input from '../../../../../components/Input';
import { useState } from 'react';

export default function EditPhoneNumber() {
    const dispatch = useDispatch();
    const profile = useSelector(selectProfile);
    const [password, setPassword] = useState('');
    const [phoneNumber, setPhoneNumber] = useState<string | undefined>('');

    const {
        otp,
        step,
        setOtp,
        setStep,
        isLoading,
        requestCode,
        confirmCode,
        responseError,
    } = useCredentialReset(() => (phoneNumber && profile) ? {
        key: password,
        email: profile.email,
        newPhoneNumber: phoneNumber,
    } : null);

    const closeModal = () => dispatch(setEditPhoneNumberModal(false));

    const submit = () => {
        switch (step) {
            case 'Request':
                requestCode();
                break;
            case 'Confirm':
                confirmCode();
                break;
            case 'Done':
                closeModal();
                break;
        }
    };

    return (
        <Modal
            size='sm'
            actions='both'
            closeFunc={closeModal}
            title='Edit phone number'
            icon={<EditSquareIcon />}
            childClassName={styles.wrapper}
            dismissButton={{
                text: 'Cancel',
                type: 'Outline-Dark',
                disabled: isLoading,
                onClick: closeModal,
            }}
            confirmButton={{
                text: 'Confirm',
                type: 'Primary',
                onClick: submit,
                disabled: !profile,
                loading: isLoading,
            }}
        >
            {step === 'Request' && (
                <>
                    <PhoneNumberInput
                        showErrorMessage
                        label='Phone number'
                        phoneNumber={phoneNumber}
                        setPhoneNumber={setPhoneNumber}
                    />
                    <Input
                        type='password'
                        value={password}
                        label='Current password'
                        onChange={setPassword}
                    />
                </>
            )}

            {step === 'Confirm' && <VerificationStep
                otp={otp}
                onOtpChange={setOtp}
                target={phoneNumber || ''}
                changeText='Change phone number'
                onChangeTarget={() => setStep('Request')}
            />}

            {step === 'Done' && <div className={styles.done}>
                <CheckSolidIcon />
                <span>
                    Phone number updated successfully
                </span>
            </div>}

            {responseError && <span className={styles.error}>{responseError}</span>}
        </Modal>
    );
};
